// App.js
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { LoadScript } from '@react-google-maps/api';
import { useEffect, useState } from 'react';
import { Hub } from 'aws-amplify/utils';
import { fetchAuthSession } from 'aws-amplify/auth';
import LandingPage from './pages/LandingPage';
import AuthenticatedApp from './pages/AuthenticatedApp';
import ProtectedRoute from './components/ProtectedRoute';
import AdminPanel from './pages/AdminPanel';


const apiKey =
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY ||
  (typeof import.meta !== 'undefined' ? import.meta.env.VITE_GOOGLE_MAPS_API_KEY : '');

const GOOGLE_MAPS_LIBRARIES = ['marker'];

export default function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const session = await fetchAuthSession();
        if (mounted) setIsAuthenticated(!!session?.tokens);
      } catch {
        if (mounted) setIsAuthenticated(false);
      } finally {
        if (mounted) setAuthChecked(true);
      }
    })();

    const unsub = Hub.listen('auth', ({ payload }) => {
      if (payload.event === 'signedIn')  setIsAuthenticated(true);
      if (payload.event === 'signedOut') setIsAuthenticated(false);
    });

    return () => { mounted = false; };

  }, []);

  if (!authChecked) return null; // or a tiny splash if you prefer

  return (
    <LoadScript googleMapsApiKey={apiKey} libraries={GOOGLE_MAPS_LIBRARIES}>
      <Routes>
        {/* Root: keep your existing conditional */}
        <Route
          path="/"
          element={isAuthenticated ? <AuthenticatedApp /> : <LandingPage />}
        />

        {/* Admin (protected) */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminPanel />
            </ProtectedRoute>
          }
        />

        {/* Fallback to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </LoadScript>
  );

  
}

